import { useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/styles/makeStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import GridItem from 'components/Grid/GridItem';

const useStyles = makeStyles({
  ...buttonsStyle,
  ...extendedFormsStyle,
});

const LinkToMenu = ({ menuPageModule, setModules }) => {
  const mainDomain = useSelector(({ Brands }) => Brands.brand.mainDomain);

  const { t } = useTranslation();
  const classes = useStyles();

  const { showMenuButton = false, menuButtonLink = '' } = menuPageModule || {};

  const menuUrlPlaceholder = `${t(
    'form.menuPlanning.defaultMenuUrl'
  )}https://${mainDomain}/menu`;

  return (
    <GridItem md={6}>
      <FormControlLabel
        control={
          <Checkbox
            name="showMenuButton"
            onClick={() =>
              setModules(prev => ({
                ...prev,
                MenuPage: {
                  ...prev.MenuPage,
                  showMenuButton: !showMenuButton,
                },
              }))
            }
            checked={showMenuButton}
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
              root: classes.checkRoot,
            }}
          />
        }
        label={t('brandCfg.menuBtnShowLink')}
      />
      <FormTextInput
        label={t('brandCfg.menuAddr')}
        classes={classes}
        placeholder={menuUrlPlaceholder}
        name="menuButtonLink"
        value={menuButtonLink}
        handleChange={e =>
          setModules(prev => ({
            ...prev,
            MenuPage: {
              ...prev.MenuPage,
              menuButtonLink: e.target.value,
            },
          }))
        }
        inputSize={12}
        maxLength={255}
      />
    </GridItem>
  );
};

export default LinkToMenu;
